import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import type { City } from '@/data/cities';

interface Props { city: City; otherCities: City[] }

const VilleVoisines = ({ city, otherCities }: Props) => (
  <section className="py-16 md:py-20 px-6 lg:px-8 bg-muted/20">
    <div className="max-w-6xl mx-auto">
      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-2">
        Nous accueillons aussi les clients de
      </h2>
      <p className="text-sm text-muted-foreground mb-8">
        Cygnature Production est facilement accessible depuis toutes les villes de la région.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {otherCities.map((c) => (
          <Link
            key={c.slug}
            to={`/ville/${c.slug}`}
            onClick={() => window.scrollTo(0, 0)}
            className="flex items-center justify-between px-4 py-3.5 rounded-xl border border-border bg-card hover:shadow-md hover:border-primary/20 transition-all group"
          >
            <div className="flex items-center gap-2.5 min-w-0">
              <MapPin size={14} className="text-primary shrink-0" strokeWidth={1.5} />
              <span className="text-sm font-heading font-medium text-foreground group-hover:text-primary transition-colors truncate">
                {c.name}
              </span>
            </div>
            <span className="text-xs text-muted-foreground shrink-0 ml-2">{c.distanceKm} km</span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default VilleVoisines;
